import { LitElement, html, css } from 'lit';
import { validateForm, validatePassword, validateEmail, gRecaptcha, validationHandler, validationHandlerClear, hideRevealPassword } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';
export class AllInSignupForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        successRedirect: { type: String },
        alreadyLoggedInMessage: { type: String },
        tooltip_1: { type: String },
        tooltip_2: { type: String },
        tooltip_3: { type: String },
        tooltip_4: { type: String },
        _successMessage: { state: true },
        _errorMessage: { state: true },
    };
    constructor() {
        super();
        this._loggedIn = document.cookie.split(';').find((row) => row.startsWith('allin_uid'))?.split('=')[1] ? true : false;
        this._loginSuccess = false;
        this._errorMessage = '';
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get noticeArea() {
        return this.shadowRoot.querySelector('.notice');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    render() {
        let markup;
        if (this._loggedIn) {
            markup = html `\n                <p>${this.alreadyLoggedInMessage}</p>\n            `;
        }
        else {
            markup = html `\n                <form action="${this.action}" method="post" @submit=${this._signup}>\n                    <div class="message notice" aria-live="polite"></div>\n                    <h2><slot name="main-header"></slot></h2>\n                    <slot name="main-header-description"></slot>\n                    <p class="small">*Sylwer: mae seren yn nodi maes gofynnol</p>\n                    <fieldset>\n                        <legend><slot name="details-header"></slot></legend>\n                        <p class="small"><slot name="details-description"></slot></p>\n                        <div class="bg">\n                            <div class="input-group">\n                                <label for="firstname">Enw cyntaf*</label>\n                                <input type="text" name="firstname" id="firstname" aria-required autocomplete="given-name">\n                            </div>\n                            <div class="input-group">\n                                <label for="lastname">Cyfenw*</label>\n                                <input type="text" name="lastname" id="lastname" aria-required autocomplete="family-name">\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset>\n                        <legend><slot name="account-details-header"></slot></legend>\n                        <p class="small"><slot name="account-details-description"></slot></p>\n                        <div class="bg">\n                            <div class="input-group">\n                                <div>\n                                    <label for="email">Rhowch eich cyfeiriad e-bost*</label>\n                                    <allin-tooltip tooltip="${this.tooltip_1}" buttontext="Pa gyfeiriad e-bost ddylwn i ei ddefnyddio?"></allin-tooltip>\n                                </div>\n                                <input type="email" name="email" id="email" aria-required autocomplete="email" @change=${this._onEmailChange}>\n                            </div>\n                            <div class="input-group">\n                                <label for="email_confirm">Cadarnhau'r cyfeiriad e-bost*</label>\n                                <input type="email" name="email_confirm" id="email_confirm" aria-required autocomplete="email" @change=${this._onEmailConfirmChange}>\n                            </div>\n                            <div class="input-group">\n                                <label for="password">Ewch ati i greu cyfrinair*</label>\n                                <div class="pword_wrapper">\n                                    <input type="password" name="password" id="password" aria-required @change=${this._onPasswordChange}>\n                                    <button data-switch="password" aria-label="Dangos cyfrinair" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                    ${eyeSvg} Dangos cyfrinair</button>\n                                </div>\n                            </div>\n                            <div class="input-group">\n                                <label for="password_confirm">Cadarnhau\u2019r cyfrinair*</label>   \n                                <div class="pword_wrapper">\n                                    <input type="password" name="password_confirm" id="password_confirm" aria-required @change=${this._onPasswordConfirmChange}>\n                                    <button data-switch="password_confirm" aria-label="Dangos cyfrinair" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                    ${eyeSvg} Dangos cyfrinair</button>\n                                </div>\n                            </div>\n                        </div>\n                        <input type="text" name="username" id="username" class="hp" autocomplete="off">\n                    </fieldset>\n                    <fieldset>\n                        <legend><slot name="block-4-header"></slot></legend>\n                        <div class="bg">\n                            <div class="input-group">\n                                <label for="language_preference"><slot name="block-4-description"></slot></label>\n                                <select name="language_preference" id="language_preference">\n                                    <option value="en" selected>Saesneg</option>\n                                    <option value="cy">Cymraeg</option>\n                                    <!-- <option value="ga">Gaeilge</option> -->\n                                    <option value="gd">Gwyddeleg</option>\n                                </select>\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset>\n                        <legend><slot name="email-preferences-header"></slot></legend>\n                        <p class="small"><slot name="email-preferences-description"></slot></p>\n                        <div class="bg">\n                            <div class="input-group">\n                                <input type="checkbox" name="email_optin" id="email_optin" aria-required data-label="Optio i mewn i gael hysbysiadau llwyfan" checked disabled><div><label for="email_optin">Hysbysiadau cyfrif a negeseuon e-bost hysbysu*</label><allin-tooltip tooltip="${this.tooltip_2}"></allin-tooltip></div>\n                            </div> \n                            <div class="input-group">\n                                <input type="checkbox" name="marketingCommunications" id="marketingCommunications" data-label="Cylchlythyr a negeseuon e-bost marchnata gan I Bawb"><div><label for="marketingCommunications">Cylchlythyr a negeseuon e-bost marchnata gan I Bawb</label><allin-tooltip tooltip="${this.tooltip_3}"></allin-tooltip></div>\n                            </div>\n                            <div class="input-group">\n                                <input type="checkbox" name="trainingCommunications" id="trainingCommunications" data-label="Negeseuon e-bost datblygu sgiliau"><div><label for="supportCommunication">Negeseuon e-bost datblygu sgiliau</label><allin-tooltip tooltip="${this.tooltip_4}"></allin-tooltip></div>\n                            </div>\n                        </div>\n                    </fieldset>\n                    <fieldset>\n                        <legend><slot name="terms-and-conditions-legend"></slot></legend>\n                        <slot name="terms-and-conditions-description" ></slot>\n                        <div class="input-group">\n                            <input type="checkbox" name="platform" id="platform" aria-required data-label="Telerau ac amodau" data-error_message="Rhaid i chi dderbyn y telerau a\u2019r amodau i barhau"><label for="platform">Rydw i wedi darllen a chytuno i\u2019r telerau ac amodau.</label>\n                        </div>\n                    </fieldset>\n                    <input type="submit" value="Creu cyfrif">\n                    <div class="notice" aria-live="assertive">\n                    </div>\n                    <slot></slot>\n                </form>\n                \n            `;
        }
        return html ` \n            <div class="signup-form">\n                ${markup}\n            </div>\n        `;
    }
    _onEmailChange(e) {
        e.preventDefault();
        let emailField = e.target;
        validationHandlerClear(emailField);
        let valid = validateEmail(emailField.value);
        if (!valid) {
            validationHandler(emailField, `Rhowch gyfeiriad e-bost dilys`);
            this.submitButton.disabled = true;
        }
        let emailConfirmField = this.form.querySelector('#email_confirm');
        if (emailConfirmField.value) {
            if (emailField.value !== emailConfirmField.value) {
                valid = false;
                validationHandler(emailConfirmField, `Dydy\u2019r cyfeiriadau e-bost ddim yr un fath`);
                this.submitButton.disabled = true;
            }
            else {
                validationHandlerClear(emailConfirmField);
            }
        }
        if (valid) {
            this.submitButton.disabled = false;
        }
    }
    _onEmailConfirmChange(e) {
        e.preventDefault();
        let emailConfirmField = e.target;
        validationHandlerClear(emailConfirmField);
        let emailField = this.form.querySelector('#email');
        if (emailField.value !== emailConfirmField.value) {
            validationHandler(emailConfirmField, `Dydy\u2019r cyfeiriadau e-bost ddim yr un fath`);
            this.submitButton.disabled = true;
        }
        else {
            validationHandlerClear(emailConfirmField);
            this.submitButton.disabled = false;
        }
    }
    _onPasswordChange(e) {
        e.preventDefault();
        const passwordField = e.target;
        const passwordConfirmField = this.form.querySelector('#password_confirm');
        // Validate password itself
        validationHandlerClear(passwordField);
        const passwordValid = validatePassword(passwordField.value);
        if (passwordValid !== true) {
            const error_message = passwordValid.join('<br>');
            validationHandler(passwordField, error_message);
        }
        // Validate password match
        validationHandlerClear(passwordConfirmField);
        if (passwordConfirmField.value && passwordConfirmField.value !== passwordField.value) {
            validationHandler(passwordConfirmField, `Mae\u2019r cyfrineiriau yn wahanol`);
        }
    }
    _onPasswordConfirmChange(e) {
        e.preventDefault();
        const passwordConfirmField = e.target;
        const passwordField = this.form.querySelector('#password');
        validationHandlerClear(passwordConfirmField);
        if (passwordConfirmField.value !== passwordField.value) {
            validationHandler(passwordConfirmField, `Mae\u2019r cyfrineiriau yn wahanol`);
        }
    }
    async _signup(e) {
        e.preventDefault();
        // Check password match before running full validation
        const passwordField = this.form.querySelector('#password');
        const passwordConfirmField = this.form.querySelector('#password_confirm');
        if (passwordField.value !== passwordConfirmField.value) {
            validationHandler(passwordConfirmField, `Mae\u2019r cyfrineiriau yn wahanol`);
        }
        // Check Terms and Conditions checkbox
        const termsCheckbox = this.form.querySelector('#platform');
        if (!termsCheckbox.checked) {
            const errorMsg = 'You must agree to the Terms and Conditions.';
            const existingHtml = this.noticeArea.innerHTML;
            this.noticeArea.innerHTML = existingHtml + `<p class="error">${errorMsg}</p>`;
        }
        // END Check Terms and Conditions checkbox
        let valid = validateForm(this.form, this.formResponse);
        // If T&C checkbox not checked, mark form as invalid
        if (!termsCheckbox.checked)
            valid = false;
        if (!valid) {
            const formContainer = this.form.closest('.signup-form') || this.form;
            formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.noticeArea.innerHTML = '';
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        let gTokenValid = await gRecaptcha(this.formResponse, this.action, this.nonce);
        if (!gTokenValid) {
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            return;
        }
        try {
            let response = await fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Signup': 'signup'
                }
            });
            response = await response.json();
            if (response.ok) {
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                window.location.href = this.successRedirect;
            }
            else {
                this.noticeArea.innerHTML = `<p class="error">${response.message}</p>`;
                //New validation for password mismatch to replace the generic error message with a more specific message
                const passwordField = this.form.querySelector('#password');
                const passwordConfirmField = this.form.querySelector('#password_confirm');
                if (passwordField.value !== passwordConfirmField.value) {
                    this.noticeArea.innerHTML = `<p class="error">${`Mae\u2019r cyfrineiriau yn wahanol`}</p>`;
                }
                //highlight email field for server side errors
                if (response.message.toLowerCase().includes('email')) {
                    const emailField = this.form.querySelector('#email');
                    validationHandler(emailField, response.message);
                }
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
                // Scroll to top so the error is visible
                const formContainer = this.form.closest('.signup-form') || this.form;
                formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
        .signup-form{
            width:680px;
            max-width:85vw;
            margin:0 auto;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }
        .input-group:has(>input[type=checkbox],>input[type=radio]){
            justify-content:flex-start;
            
        }
        div:has(>allin-tooltip){
            position:relative;
            display:flex;
            justify-content:space-between;
            flex-wrap:wrap;
        }

        div:has(>allin-tooltip) label{
            width:fit-content;
        }
        input[type=checkbox]:disabled{
            filter: brightness(0.6) contrast(9);
        }
        `
    ];
}
